import { map, pathOr, pick, pipe, prop } from 'ramda';
import { storeNamespace } from '../../shared/utils/store.utils';
import { THREE_SIXTY_EVALUATION_NAMESPACE } from '../store/store.constant';

export const tseNamespace = storeNamespace(THREE_SIXTY_EVALUATION_NAMESPACE);

export const getIds = map(prop('id'));

export const getStepLabels = labels => [
	{ label: 'Escoge puestos' },
	...map(item => ({ label: item }), labels),
	{ label: 'Preguntas' },
	{ label: 'Respuesta' },
];

export const transformSkillData = dataRaw =>
	pipe(
		map(skillGroup => ({
			...pick(['code', 'name', 'description', 'id'], skillGroup),
			skills: map(
				skill => ({
					...pick(['code', 'name', 'description', 'id'], skill),
					parent: {
						name: skillGroup.name,
						id: skillGroup.id,
					},
					levels: map(
						level => ({
							...pick(['code', 'name', 'description', 'id'], level),
							questions: map(
								question => ({
									...pick(['code', 'description', 'id'], question),
									firstPerson: pathOr('-', ['additionalInformation', 'firstPerson'], question),
									thirdPerson: pathOr('-', ['name'], question),
								}),
								level.entities || [],
							),
						}),
						skill.entities || [],
					),
				}),
				skillGroup.entities || [],
			),
		})),
	)(dataRaw || []);

export default {};



// WEBPACK FOOTER //
// ./src/modules/three-sixty-evaluation/utils/index.js